import { useEffect, useState } from "react"

import DateRangePicker from "../dateRangePicker/dateRangePicker"
import { DATE_TIME_FORMAT } from "constants"
import { dateTimeFunction } from "utils/date"
import DateTime from "utils/dateTime"
import { t } from "i18next"

export default function SimpleDateRangeFilter({
  onSelect,
  value: dateValue,
  valueFormat = DATE_TIME_FORMAT,
  label,
  splitBy = ",",
  ...rest
}) {
  const [value, setValue] = useState()

  const getConvertedDateValue = dates => {
    return `${dateTimeFunction({
      date: DateTime.formatDate(DateTime.getStartOfDay(dates[0]),valueFormat),
      apiRequest: true,
      timeZone: true,
    })},${dateTimeFunction({ date: DateTime.formatDate(DateTime.getEndOfDay(dates[1]),valueFormat), timeZone: true, apiRequest: true })}`
  }

  const getDateValueFromString = value => {
    if (value) {
      return value?.split(splitBy)
    }
    return undefined
  }

  useEffect(() => {
    setValue(!!dateValue ? dateValue : null)
  }, [dateValue])

  return (
    <>
      <label className="d-block">{label}</label>
      <DateRangePicker
        onChange={(dates) => {
          dates && onSelect(getConvertedDateValue(dates));
        }}
        // disabledDate={disabledDate}
        value={getDateValueFromString(value)}
        noDefault
        inputReadOnly
        placeholder={
          rest?.placeholder ||
          (rest?.picker === "month"
            ? [t("Start month"), t("End month")]
            : [t("Start date"), t("End date")])
        }
        {...rest}
      />
    </>
  );
}
